export default {
  UNPUBLISHED: 0,
  PUBLISHED_PHOTOS_ONLY: 1,
  PUBLISHED_POCKET_WEBSITE: 2,
  PUBLISHED_LITE: 3,
  PUBLISHED_FULLY: 4,
  PUBLISHED_FREE_POCKET_WEBSITE: 5,
};
